import React from "react";
import {
  DateRangePicker,
  DateRange,
} from "@rolfkoenders/react-daterange-picker";
import CalenderIcon from '../assets/icons/Expire-Date.svg';
import styled from 'styled-components';

class DateRangePickerWrapper extends React.Component {
  state = {
    open: false,
    dateRange: {},
    rangeText: ""
  };
  componentDidMount() {
    this.updateDateRangeText(this.props.initialDateRange);
  }
  dateConvertor(date) {
      let twoDigits = (num) => num > 9? num: "0" + num;
      return date.getFullYear() + "-" + twoDigits(date.getMonth() + 1) + "-" + twoDigits(date.getDate());
  }
  updateDateRangeText(range) {
    this.setState({
        open: false,
        dateRange: range,
        rangeText: this.dateConvertor(range.startDate) + " : " + this.dateConvertor(range.endDate)
    });
  }
  dateChanged(range) {
    this.updateDateRangeText(range);
    this.props.dateRangeChanged(range);
  }
  openDateRangeCalendar() {
      this.setState({
          open: true
      });
  }
  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.initialDateRange !== prevProps.initialDateRange) {
      this.updateDateRangeText(this.props.initialDateRange);
    }
  }
  hideDatePicker($evt) {
    if ($evt?.target.id == "background") {
        this.setState({
            open: false
        });
    }
  }
  clearTime(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
  }
  render() {
    let minDate = new Date();
    minDate.setMonth(minDate.getMonth() - 3);
    minDate.setDate(1);
    this.clearTime(minDate);
    let maxDate = new Date();
    this.clearTime(maxDate);
    return (
        <Container>
            <div onClick={this.openDateRangeCalendar.bind(this)}>
                <DatePickerText type="text" value={this.state.rangeText} readOnly />
                <img src={CalenderIcon} alt="" style={{ height: "25px"}}></img>
            </div>
            {this.state.open? 
                <PickerBackground onClick={this.hideDatePicker.bind(this)} id="background">
                    <DateRangePicker
                        initialDateRange={this.props.initialDateRange}
                        open={this.state.open}
                        minDate={minDate}
                        maxDate={maxDate}
                        onChange={this.dateChanged.bind(this)}
                    />
                </PickerBackground>
                : <div></div>}
        </Container>
    );
  }
}

const Container = styled.div`
    border: 1px solid #B2B3B7;
    background-color: #f8f8f8;
    border-radius: unset;
    color: #B2B3B7;
    padding: 4px 15px;
    cursor: pointer;
    margin-left: 20px;
`;
const DatePickerText = styled.input`
    border: unset;
    font-size: 14px;
    color: #070F1A;
    background-color: #f8f8f8;
    cursor: pointer;
    padding-top: 2px
`;
const PickerBackground = styled.div`
    position: absolute;
    background-color: rgba(0,0,0, 0.1);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;
export default DateRangePickerWrapper;